import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=54221a82&scoped=true"
import script from "./deal.vue?vue&type=script&lang=js"
export * from "./deal.vue?vue&type=script&lang=js"
import style0 from "./deal.vue?vue&type=style&index=0&id=54221a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54221a82",
  null
  
)

export default component.exports